import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M19.6 1.4C19.3 1.2 19 1.2 18.7 1.3L14 2.9V3C14 1.4 12.6 0 11 0H2.8C1.3 0 0 1.3 0 2.9V9.2C0 10.7 1.3 12 2.8 12H11.1C12.7 12 14 10.7 14 9.1L18.7 10.7C18.8 10.7 18.9 10.8 19 10.8C19.2 10.8 19.4 10.7 19.6 10.6C19.9 10.4 20 10.1 20 9.8V2.3C20 1.9 19.9 1.6 19.6 1.4ZM12 9.1C12 9.6 11.6 10 11.1 10H2.8C2.4 10 2 9.6 2 9.1V2.9C2 2.4 2.4 2 2.8 2H11C11.6 2 12 2.4 12 3V9.1ZM18 8.4L14 7V5L18 3.7V8.4Z",
];

export function VideosIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
